import { render, staticRenderFns } from "./LabeledValue.vue?vue&type=template&id=677ae0a3&"
import script from "./LabeledValue.vue?vue&type=script&lang=js&"
export * from "./LabeledValue.vue?vue&type=script&lang=js&"
import style0 from "./LabeledValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports